import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ManualScrollerWrapperArrow} from "./manual-scroll-wrapper.arrow";

export class ManualScrollerWrapperArrowsProps extends BaseProps {
  isDownScrollAllow: Boolean;
  isUpScrollAllow: Boolean;
  onDownClick: Function;
  onUpClick: Function;
}

export const ManualScrollerWrapperArrows = (props: ManualScrollerWrapperArrowsProps) => {
  const arrowDownProps = {
    isActive: props.isDownScrollAllow,
    className: 'manual-scroll-wrapper-down-arrow',
    activeClassName: 'manual-scroll-wrapper-active-down-arrow',
    onClick: () => props.onDownClick()
  }

  const arrowUpProps = {
    isActive: props.isUpScrollAllow,
    className: 'manual-scroll-wrapper-up-arrow',
    activeClassName: 'manual-scroll-wrapper-active-up-arrow',
    onClick: () => props.onUpClick()
  }

  return (
    <div className={'manual-scroll-wrapper-arrows-container'}>
      <ManualScrollerWrapperArrow {...arrowDownProps}/>
      <ManualScrollerWrapperArrow {...arrowUpProps}/>
    </div>
  )
};